<template>
  <div class="modal-popup">
    <div class="modal fade cruise-deck-popup" id="cruiseDeckPopup" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" v-if="deck != null">
          <div class="modal-header">
            <h5 class="modal-title title" v-if="popupState === 'update'">Update Deck ({{deck.name}})</h5>
            <h5 class="modal-title title" v-if="popupState === 'create'">Create a new Deck</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <form method="post" id="cruiseDeckFrom">
                <div class="row">
                  <div class="col-sm-6">
                    <base-edit-input
                        v-model="deck.name"
                        :rules="'required'"
                        :type="'text'"
                        :label="'Adı'">
                    </base-edit-input>
                  </div>
                  <div class="col-sm-6">
                    <base-edit-input
                        v-model="deck.order"
                        :rules="'required|min_value:1'"
                        :type="'number'"
                        :label="'Sıralaması'">
                    </base-edit-input>
                  </div>
                  <div class="col-sm-6">
                    <base-image-edit-input
                        v-model="deck.imageUrl"
                        :rules="'required'">
                    </base-image-edit-input>
                  </div>
                  <div class="col-sm-6">
                    <base-edit-input
                        v-model="deck.imageName"
                        :rules="'required'"
                        :type="'text'"
                        :label="'Resim Adı'">
                    </base-edit-input>
                  </div>
                </div>
              </form>
            </div><!-- end contact-form-action -->
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">Cancel</button>
            <button v-if="deck.id != null" :class="{'disabled' : !formValid}" @click="update" type="button" class="theme-btn theme-btn-small">Güncelle</button>
            <button v-if="deck.id == null" :class="{'disabled' : !formValid}" @click="create" type="button" class="theme-btn theme-btn-small">Kaydet</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadImage from "../../common/UploadImage";
import BaseEditInput from "../../base/BaseEditInput";
import BaseImageEditInput from "../../base/BaseImageEditInput";
import validationFormUtils from "../../../util/validationFormUtils";

export default {
  name: "DeckDetail",
  components: {UploadImage, BaseEditInput, BaseImageEditInput},
  data:function (){
    return{
      formValid:false
    }
  },
  computed:{
    deck:{
      get(){
        return this.$store.getters.getDeck;
      }
    },
    popupState : {
      get(){
        if(this.deck.id === null){
          return "create";
        } else{
          return "update";
        }
      }
    }
  },
  methods:{
    create(){
      if(this.formValid) {
        this.$store.dispatch("createDeck", this.deck).then(response => {
          $(".modal").modal('hide');
          Swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: '',
          })
        });
      }
    },
    update(){
      if(this.formValid) {
        this.$store.dispatch("updateDeck",this.deck).then(response => {
          $(".modal").modal('hide');

          Swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: '',
          })
        })
      }
    }
  },
  watch:{
    deck:{
      deep:true,
      handler:function (){
        validationFormUtils.checkFormFields(this);
      }
    }
  }
}


</script>

<style scoped>

</style>